import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

const Unauthorized = () => {
  return (
    <div style={{ textAlign: 'center', margin: '50px 0' }}>
      <h4>
        <FormattedMessage id="app.unauthorized.message" defaultMessage="403" />
      </h4>
      <Link to="/">
        {' '}
        <FormattedMessage
          id="app.unauthorized.link"
          defaultMessage="Back"
        />{' '}
      </Link>
    </div>
  );
};

export default Unauthorized;
